import {React} from "react";
import axios from "axios";
import {toast} from "react-toastify";
import { useParams } from 'react-router-dom'

const RequestCar = () => {
    const { transactionId,valetId,cusId,token } = useParams();
    const handleRequestVehicle = async (id_valet, processId) => {
        const message = window.prompt("Ingrese un mensaje opcional para el valet:");
        if (message === null) return;

        const notificationData = {
            id_user: cusId,
            id_valet: id_valet,
            message: message || "",
            require_read: 1,
            process_id: processId,
            requested: 1,
        };

        try {
            await axios.post(`${process.env.REACT_APP_PUBLIC_SERVER}/api/notifications`, notificationData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            toast.success("Solicitud enviada al valet.");
        } catch (error) {
            console.error("Error al enviar la solicitud:", error);
            toast.error("Error al enviar la solicitud.");
        }
    };
    return(
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-5">
                    <div class="message-box _success">
                        <i class="fa fa-check-circle" aria-hidden="true"></i>
                        <h2> Puedes solicitar tu vehiculo haciendo click aqui! </h2>
                        <p> <button className="btm-sm btn-info form-control" onClick={() => handleRequestVehicle(valetId,transactionId)}>Solicitar</button> </p>
                    </div>
                </div>
            </div>
            <hr/>
        </div>
)
}

export default RequestCar
